import React from 'react';
import { Box, Typography } from '@mui/material';

const PickyKittyBubble = ({ children, mt, mb }) => {
  return (
    <Box
      className="picky-kitty-speech-bubble"
      sx={{
        mt: mt !== undefined ? mt : { xs: 1.5, sm: 2 },
        mb: mb !== undefined ? mb : 0,
        position: 'relative',
        maxWidth: '600px',
        mx: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
        gap: { xs: 1, sm: 1.25 }
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: { xs: '45px', sm: '50px' },
          height: { xs: '45px', sm: '50px' },
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #F5E6D0 0%, #F0DCB8 100%)',
          border: '1.5px solid rgba(184, 154, 122, 0.3)',
          boxShadow: '0 4px 12px rgba(184, 154, 122, 0.15), 0 2px 4px rgba(0, 0, 0, 0.05), inset 0 1px 2px rgba(255, 255, 255, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px',
          position: 'relative',
          zIndex: 2,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 6px 16px rgba(184, 154, 122, 0.2), 0 2px 6px rgba(0, 0, 0, 0.08)'
          }
        }}
      >
        <img
          src="/picky-kitty/profile_pic.PNG"
          alt="Picky Kitty"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </Box>

      <Box
        sx={{
          position: 'relative',
          flex: 1,
          p: { xs: 1.5, sm: 2 },
          background: 'linear-gradient(135deg, #F5E6D0 0%, #F8EDDD 100%)',
          border: '1px solid rgba(184, 154, 122, 0.25)',
          borderRadius: '18px',
          boxShadow: '0 4px 20px rgba(184, 154, 122, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(10px)',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: '-8px',
            top: '18px',
            width: '12px',
            height: '12px',
            borderRadius: '0 0 0 3px',
            background: 'linear-gradient(135deg, #F5E6D0 0%, #F8EDDD 100%)',
            borderLeft: '1px solid rgba(184, 154, 122, 0.25)',
            borderBottom: '1px solid rgba(184, 154, 122, 0.25)',
            transform: 'rotate(45deg)',
            boxShadow: '-2px 2px 4px rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.875rem', sm: '0.95rem' },
            lineHeight: 1.5,
            color: '#A68B6F',
            margin: 0,
            fontWeight: 400
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );
};

export default PickyKittyBubble;
